import type { Staff } from "@/lib/authv2/store";
import { ACTION } from "@/lib/auth/actions";
import { isActiveShiftLead } from "@/lib/auth/shift-lead";
import { hasPermission } from "@/lib/authv2/permissions";

/** Phòng ban đứng quầy — điều phối bảng là việc hằng ngày của họ. */
const DISPATCH_DEPTS = new Set(["reception"]);

function inDispatchDept(staff: Staff): boolean {
  return DISPATCH_DEPTS.has((staff.department || "").trim().toLowerCase());
}

/**
 * Ai được mở bảng điều phối. Bản sao đúng cổng backend `manageOrLead`:
 * có quyền quản bảng (admin / giám đốc / trưởng phòng / điều phối) HOẶC
 * thuộc phòng lễ tân (`auth.AllowOrDept("storeboard.manage", "reception")`),
 * HOẶC đang làm ca trưởng trong giờ ca ± 2 tiếng (QĐ 0259 — quyền theo CA,
 * cơ sở cụ thể do máy chủ soát).
 *
 * Bạn makeup và bạn chụp cố tình KHÔNG nằm ở đây — họ không cần nhìn cả
 * bảng, chỉ cần thẻ "Khách của bạn" trên điện thoại (một nút Xong).
 */
export function canSeeStoreBoard(staff: Staff | null | undefined): boolean {
  if (!staff) return false;
  if (hasPermission(ACTION.StoreboardManage)) return true;
  if (inDispatchDept(staff)) return true;
  // Ca trưởng đang trong giờ ca ± 2 tiếng (QĐ 0259) — bản sao cổng
  // `manageOrLead` của máy chủ. Cơ sở cụ thể do máy chủ soát.
  return isActiveShiftLead();
}

/** Vào bảng CHỈ nhờ đang làm ca trưởng: màn khoá cơ sở về ca (QĐ 0259; mọi nút như lễ tân — CEO Câu 2c). */
export function seesStoreBoardOnlyAsShiftLead(staff: Staff | null | undefined): boolean {
  if (!staff) return false;
  return !hasPermission(ACTION.StoreboardManage) && !inDispatchDept(staff) && isActiveShiftLead();
}
